class OrdersApi {
    constructor(api, opts) {
        this.api = api;
        this.options = {
            ...opts,
        };
    }

    create(data) {
        return this.api.requestPost(this.api.route('orders.store'), data, {
            withCredentials: true,
        });
    }

    update(data) {
        const { id = null } = data || {};
        const url = this.api.route('orders.update', { order: id || '1' });
        return this.api.requestPatch(url, data, {
            withCredentials: true,
        });
    }

    destroy(id) {
        return this.api.requestPost(
            this.api.route('orders.destroy'),
            { id },
            {
                withCredentials: true,
            },
        );
    }
}

export default OrdersApi;
